export const SplashScreenViewGrid = {
	size: 100,
	gap: 0,
	padding: {
		top: 1,
		bottom: 1,
		left: 3,
		right: 6,
		landscape: {
			top: 1,
			bottom: 1,
			left: 3,
			right: 3
		},
		portrate: {
			top: 5,
			bottom: 5,
			left: 8,
			right: 8
		}
	},

	main: [
		{
			name: 'leftgrid',
			size: 70,
			type: 'PortrateGridController',
			config: {
				size: 100,
				gap: 1,
				padding: {
					top: 3,
					bottom: 2,
					left: 7
				},
				main: [
					{
						name: 'logo',
						size: 18,
						bounds: {
							width: 499,
							height: 206
						}
					},
					{
						name: 'empty',
						size: 0.2
					},
					{
						name: 'slider_bg',
						size: 66,
						align: 'top_center'
					}
				]
			}
		},
		{
			name: 'rightgrid',
			type: 'PortrateGridController',
			size: 30,
			config: {
				gap: 1,
				size: 100,
				align: 'left',
				padding: {
					top: 0,
					bottom: 5,
					right: 10
				},
				main: [
					{
						name: 'fg',
						size: 53,
						align: 'bottom_center'
					},
					{
						name: 'texts',
						size: 18,
						align: 'top_center'
					},
					{
						name: 'ui_splash_screen_btn',
						size: 17,
						align: 'top_right'
					},
					{
						name: 'ui_splash_screen_checkbox',
						size: 6,
						align: 'top_center',
						bounds: {
							width: 250,
							height: 50
						}
					}
				]
			}
		}
	],

	portrate: [
		{
			name: 'logo',
			size: 14,
			align: 'center'
			// bounds: {
			//   width: 249,
			//   height: 103,
			// },
		},
		{
			name: 'fg',
			visible: false
		},
		{
			name: 'slider_bg',
			align: 'top_center',
			size: 40,
			bounds: {
				width: 982,
				height: 672
			}
			//  width: 90,
			//  height: 90,
		},
		{
			name: 'empty',
			size: 6
		},
		{
			name: 'texts',
			size: 10,
			// align: 'bottom_center',
			bounds: {
				width: 446,
				height: 111
			}
		},
		{
			name: 'empty',
			size: 9
		},

		{
			name: 'ui_splash_screen_btn',
			size: 17,
			align: 'center',
			bounds: {
				width: 278,
				height: 160
			}
		},
		{
			name: 'empty',
			size: 5
		},
		{
			name: 'ui_splash_screen_checkbox',
			size: 7
		}
	],

	landscape: [
		{
			name: 'leftgrid-land',
			size: 70,
			type: 'PortrateGridController',
			config: {
				size: 100,
				gap: 1,
				padding: {
					top: 3,
					bottom: 2,
					left: 7
				},
				main: [
					{
						name: 'logo',
						size: 23,
						bounds: {
							width: 499,
							height: 206
						}
					},
					{
						name: 'empty',
						size: 0.2
					},
					{
						name: 'slider_bg',
						size: 76,
						align: 'top_center'
					}
				]
			}
		},
		{
			name: 'rightgrid-land',
			type: 'PortrateGridController',
			size: 30,
			config: {
				gap: 1,
				size: 100,
				align: 'left',
				padding: {
					top: 0,
					bottom: 5
				},
				main: [
					{ name: 'empty', size: 10 },
					{
						name: 'fg',
						size: 45,
						align: 'bottom_center',
						bounds: {
							width: 196,
							height: 305
						}
					},
					{
						name: 'texts',
						size: 20,
						align: 'top_center'
					},
					{ name: 'empty', size: 4 },
					{
						name: 'ui_splash_screen_btn',
						size: 21,
						align: 'top_right',
						bounds: {
							width: 258,
							height: 160
						}
					},
					{ name: 'empty', size: 0.5 },
					{
						name: 'ui_splash_screen_checkbox',
						size: 8,
						align: 'top_center',
						bounds: {
							width: 250,
							height: 50
						}
					}
				]
			}
		}
	]
};
